export default "__VITE_ASSET__VBSrV55G__"